<app-simple-table
  [tableData]="tableData"
  (headerSelected)="sort($event)"
></app-simple-table>
